import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import styles from './HeaderImage.css'

class HeaderImage extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg
          enableBackground="new 423.2 281.9 1125 237.8"
          height="100%"
          preserveAspectRatio="none"
          viewBox="423.2 281.9 1125 237.8"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
          xmlSpace="preserve"
        >
          <path
            className={styles.pathColor}
            d="M423.2,440c127.8,48.4,332.2,79.7,562.5,79.7s434.7-31.3,562.5-79.7V281.9h-1125V440z"
            width="100%"
          />
        </svg>
      </div>
    )
  }
}

HeaderImage.propTypes = {
  className: PropTypes.string,
}

export default HeaderImage
